import React from 'react';
import style from './style.scss'

const Select = (props) => {
    const {field} = props;
if( Array.isArray(field.options) ) {
    return (<div className="form-group">
        <label
            className={style.formLabel}
            htmlFor={field.elementId}
        >
            {field.label}{field.required && <span className={style.asterisk}> *</span>}
        </label>

        <select
            id={field.elementId}
            name={field.name}
            className={style.fieldSelect}
        >
            <option value="" disabled>
                {props.field.placeholder}
            </option>

            { field.options.map((option, i) => { // console.log(option)
                return (
                    <option
                        key={i}
                        value={option.value}
                        selected={option.selected}
                    >
                        {option.label}    
                    </option>
                );

            }) }
        </select>
    </div>)
  }  else {
    return (<div className="form-group">
        <label
            className={style.formLabel}
            htmlFor={field.elementId}
        >
            {field.label}{field.required && <span className={style.asterisk}> *</span>}
        </label>

        <select
            id={field.elementId}
            name={field.name}
            className={style.fieldSelect}
        >
            <option value="" disabled>
                {props.field.placeholder}
            </option>

            { /* console.log(field.options) */ }
            { Object.keys(field.options).map((option, i) => {

                return (
                    <option
                        key={i}
                        // value={option.value}
                        value={option}
                        selected={option.selected}
                    >
                        {field.options[option]}
                        { /*option.label*/ }
                    </option>
                );

            }) }
        </select>
    </div>)
  }


}

export default Select;
